import { render, staticRenderFns } from "./DevSidebar.vue?vue&type=template&id=46b8a0d6&scoped=true&"
import script from "./DevSidebar.vue?vue&type=script&lang=js&"
export * from "./DevSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DevSidebar.vue?vue&type=style&index=0&id=46b8a0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b8a0d6",
  null
  
)

export default component.exports